import { render } from "./RecuperarPasswordView.vue?vue&type=template&id=91d6e61a&ts=true"
import script from "./RecuperarPasswordView.vue?vue&type=script&lang=ts"
export * from "./RecuperarPasswordView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__